import { Icon } from '@iconify/react';
import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const addressDataList = [
  <>
    Sadanand Business Centre,<br />
    Baner, Pune-411045
  </>,
  '+91-8210656859',
  'info@brandgazm.com',
];
const serviceMenuList = [
  {
    title: 'Brand Identity Design',
    href: '/brand-identity-design',
  },
  {
    title: 'Video Production',
    href: '/video-production',
  },
  {
    title: 'Web Design & Dev',
    href: '/web-dev-design',
  },
  {
    title: 'Packaging Design',
    href: 'packaging-design',
  },

  {
    title: 'Creative Campaigns',
    href: '/creative-campaigns',
  },
  // {
  //   title: 'Ad Promotion',
  //   href: '/service/service-details',
  // },
];
const LinksMenuList = [
  {
    title: 'Home',
    href: '/',
  },
  {
    title: 'Who Dis ',
    href: '/about',
  },
  {
    title: 'Magic We Make',
    href: '/service',
  },
  // {
  //   title: 'Show Offs',
  //   href: 'portfolio',
  // },
  // {
  //   title: 'Brain Sparks',
  //   href: '/blog',
  // },
  {
    title: 'Hit Us Up',
    href: '/contact',
  },
];
const policyMenuList = [
  {
    title: 'Terms of Use',
    href: '/',
  },
  {
    title: 'Privacy Policy',
    href: '/',
  },
];
const socialBtnList = [
  {
    icon: 'fa6-brands:linkedin-in',
    href: 'https://www.linkedin.com/company/brandgazm/',
  },
  {
    icon: 'fa6-brands:instagram',
    href: 'https://www.instagram.com/brandgazm?igsh=Mm1mM3dtbzI4Zjcx',
  },
  // {
  //   icon: 'fa6-brands:youtube',
  //   href: '/',
  // },
  // {
  //   icon: 'fa6-brands:facebook-f',
  //   href: '/',
  // },
];
export default function Footer() {
  return (
    <footer
      className="cs_fooer cs_bg_filed"
      style={{ backgroundImage: 'url(/images/footer_bg.jpeg)' }}
    >
      <div className="cs_fooer_main">
        <div className="container">
          <div className="row">
            <div className="col-lg-3 col-sm-6">
              <div className="cs_footer_item">
                <div className="footer-logo-wrapper">
                  <img
                    // src="/images/brandgazamfull.png"
                    src="/images/brandgazmbg.png"

                    alt="Brandgazm Logo"
                    className="footer-logo"
                  />
                </div>
                <ul className="cs_menu_widget cs_mp0">
                  {addressDataList.map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>
              </div>
            </div>

            <div className="col-lg-3 col-sm-6">
              <div className="cs_footer_item">
                <h2 className="cs_widget_title">Services</h2>
                <ul className="cs_menu_widget cs_mp0">
                  {serviceMenuList.map((item, index) => (
                    <li key={index}>
                      <Link to={item.href}>{item.title}</Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
            <div className="col-lg-3 col-sm-6">
              <div className="cs_footer_item">
                <h2 className="cs_widget_title">Links</h2>
                <ul className="cs_menu_widget cs_mp0">
                  {LinksMenuList.map((item, index) => (
                    <li key={index}>
                      <Link to={item.href}>{item.title}</Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
            <div className="col-lg-3 col-sm-6">
              <div className="cs_footer_item">
                <h2 className="cs_widget_title">Get the Creative Hit First</h2>
                <div className="cs_newsletter cs_style_1">
                  <div className="cs_newsletter_text">
                    We only send the good stuff — sharp insights, creative inspiration, and updates that actually matter to your brand.
                  </div>
                  <form action="#" className="cs_newsletter_form">
                    <input
                      type="email"
                      className="cs_newsletter_input"
                      placeholder="Email addressss"
                    />
                    <button className="cs_btn cs_style_1">
                      Submit
                      <span>
                        <i>
                          <Icon icon="fa6-solid:arrow-right" />
                        </i>
                        <i>
                          <Icon icon="fa6-solid:arrow-right" />
                        </i>
                      </span>
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="cs_bottom_footer">
          {/* <div className="cs_bottom_footer_left">
            <div className="cs_social_btns cs_style_1">
              {socialBtnList.map((item, index) => (
                <Link to={item.href} className="cs_center" key={index}>
                  <Icon icon={item.icon} />
                </Link>
              ))}
            </div>
          </div> */}
          <div className="cs_bottom_footer_left">
            <div className="cs_social_btns cs_style_1">
              {socialBtnList.map((item, index) => (
                <a
                  href={item.href}
                  className="cs_center"
                  key={index}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Icon icon={item.icon} />
                </a>
              ))}
            </div>
          </div>

          <div className="cs_copyright">Copyright ©2025 Brandgazam.</div>
          <div className="cs_bottom_footer_right">
            <ul className="cs_footer_links cs_mp0">
              {policyMenuList.map((item, index) => (
                <li key={index}>
                  <Link to={item.href}>{item.title}</Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
}
